import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    query: '',
  },
  pagination: {
    pageSize: 20,
    page: 1,
  },
};

export const ingredientsSearchFiltersSlice = createSlice({
  name: 'ingredientsSearchFilters',
  initialState,
  reducers: {
    setIngredientsSearchFiltersPage: (state, action) => {
      state.pagination.page = action.payload;
    },
    setIngredientsSearchFilters: (state, action) => {
      state.filters = action.payload;
    },
    updateIngredientsSearchFiltersState: (state, { payload: { filters, pagination } }) => {
      state.filters = filters;
      state.pagination = pagination;
    },
  },
  selectors: {
    selectIngredientsSearchFiltersPagination: ({ pagination }) => pagination,
    selectIngredientsSearchFilters: ({ filters }) => filters,
  },
});

export const { setIngredientsSearchFiltersPage, setIngredientsSearchFilters, updateIngredientsSearchFiltersState } =
  ingredientsSearchFiltersSlice.actions;
export const { selectIngredientsSearchFiltersPagination, selectIngredientsSearchFilters } =
  ingredientsSearchFiltersSlice.selectors;
export default ingredientsSearchFiltersSlice.reducer;
